export const errorAnalytics = (error: any): string => {
  let errorMsg = '';

  switch (error?.name) {
    case 'ServiceError':
      errorMsg = 'Error: NASU - API';
      break;
    case 'ValidationError':
      errorMsg = 'Error: NASU - VALIDATION';
      break;
    default:
      errorMsg = 'Error: NASU - JS';
  }

  return errorMsg;
};
